<template>
  <v-content :style="{color:style.fontColor}" v-if="userIsAuthenticated">
    <v-container>
      <v-row class="pl-5 pr-5" >
        <v-col>
          <v-form @submit.prevent="onCreateProduct">
            <v-row>
              <v-col cols="12">
                <h1 class="font-weight-bold" :style="`color:${mainColor}`">Ingresa un nuevo producto</h1>
                <v-row class="mt-5 mb-5"  >
                  <v-col cols="6">
                    <v-card>
                      <v-container>
                        <v-card-title>
                          <h3>Nombre del producto</h3>
                        </v-card-title>
                        <v-row class="pa-4" >
                          <v-col>
                            <v-row>
                              <v-text-field
                                v-model="productName"
                                name="productName"
                                id="productName"
                                :counter="max3"
                                :rules="[rules.counter3, rules.required]"
                                type="text"
                                outlined
                              ></v-text-field>
                            </v-row>
                            <v-row>
                              <v-col cols="12">
                                <h4>Nombre alternativo 1</h4>
                              </v-col>
                              <v-text-field
                                v-model="alterName1"
                                name="alterName1"
                                id="alterName1"
                                :counter="max3"
                                :rules="[rules.counter3]"
                                type="text"
                                filled
                              ></v-text-field>
                            </v-row>
                            <v-row>
                              <v-col cols="12">
                                <h4>Nombre alternativo 2</h4>
                              </v-col>
                              <v-text-field
                                v-model="alterName2"
                                name="alterName2"
                                id="alterName2"
                                :counter="max3"
                                :rules="[rules.counter3]"
                                type="text"
                                filled
                              ></v-text-field>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card>
                  </v-col>
                  <v-col cols="3" offset="3">
                    <h3 class="mb-3">Estado del producto</h3>
                    <p style="font-weight: bold">
                      Estado:
                    </p>
                    <v-select
                        v-model="status"
                        :items="statusSelect"
                      @change="changeStatus"
                        class="mb-4 mr-5"
                    ></v-select>
                    <p style="font-weight: bold">
                      Stock:
                      <span
                        style="font-weight: 400"
                      >{{productStock === 0 ? 'Sin unidades' : productStock === 1 ?  `${productStock} unidad`: `${productStock} unidades`}}</span>
                    </p>
                    <p style="font-weight: bold">Usar variaciones:</p>
                    <v-switch
                        v-model="hasVariations"
                        label="Activar"
                        class="pl-5"
                        @change="activateImageForVariations()"
                    ></v-switch>
                    <p style="font-weight: bold" v-if="hasVariations">Usar imagenes del producto en variaciones:</p>
                    <v-switch
                        v-if="hasVariations"
                        v-model="useImagesForVariations"
                        label="Activar"
                        class="pl-5"
                    ></v-switch>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-card>
                      <v-row>
                        <v-col cols="6" class="pt-0">
                          <v-row>
                            <v-col>
                              <v-card-title>
                                <h3>Keywords</h3>
                              </v-card-title>
                              <v-card-text>
                                <p>Agrega palabras claves para ser usadas en las búsquedas, como ser: mujer, zapato, deportivo, negro, etc. Escribe una palabra a la vez, ten cuidado con la ortografía y utiliza sólo el singular.</p>
                              </v-card-text>
                            </v-col>
                          </v-row>
                          <v-row class="pb-4 pl-6 pr-6" >
                            <v-col>
                              <v-combobox
                                v-model="keywords"
                                hide-selected
                                label="Escribe la keyword y preciona enter"
                                multiple
                                persistent-hint
                                small-chips
                                deletable-chips
                              ></v-combobox>
                            </v-col>
                          </v-row>
                        </v-col>
                        <v-col class="pl-3 pt-0" cols="6" >
                          <v-row>
                            <v-col cols="12" :style="{borderLeft:style.border}" class="mt-4">
                              <v-card-title class="pt-0">
                                <h3>Selecciona la categoría</h3>
                              </v-card-title>
                              <v-content
                                v-for="(categoryName, index) in selectedCategoryNames"
                                :key="index"
                                class="pt-4 pl-0"
                              >
                                <v-row class="pl-4 pt-4 pr-6">
                                  <v-col cols="10">
                                    <v-select
                                      v-model="categoryName.name"
                                      :items="selectCategories"
                                      label="Elige una categoría"
                                      id="categories"
                                      @change="addCategory(index)"
                                      solo
                                    ></v-select>
                                  </v-col>
                                  <v-col cols="2" v-if="index > 0">
                                    <v-btn
                                      @click="removeCategoryBlock(index)"
                                      dark
                                      fab
                                      small
                                      absolute
                                      icon
                                      color="grey"
                                    >
                                    <v-icon>{{deleteIcon}}</v-icon>
                                  </v-btn>
                                  </v-col>
                                </v-row>
                                <v-row
                                  v-if="categoryName !== ''"
                                  justify="center"
                                >
                                    <v-tooltip
                                      bottom
                                      v-if="index + 1 === selectedCategoryNames.length"
                                    >
                                      <template v-slot:activator="{on}">
                                        <v-btn
                                          @click="addCategoryBlock(index)"
                                          dark
                                          fab
                                          icon
                                          :color="mainColor"
                                          v-on="on"
                                          x-large
                                        >
                                          <v-icon>{{addIcon}}</v-icon>
                                        </v-btn>
                                      </template>
                                      <span>Agregar categoría</span>
                                    </v-tooltip>
                                </v-row>
                              </v-content>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <template>
                  <v-spacer></v-spacer>
                  <loading-dialog :onLoading="onLoading" />
                </template>
                <template>
                  <load-image-dialog
                    :LoadImageDialogProps="LoadImageDialogProps"
                    :companyId="companyId"
                  />
                </template>
                <template>
                  <load-video-dialog
                    :LoadVideoDialogProps="LoadVideoDialogProps"
                    :companyId="companyId"
                  />
                </template>
              </v-col>
            </v-row>
            <v-row class="mb-5">
              <v-col cols="12">
                <v-card>
                  <v-row>
                    <v-col cols="12" class="pt-0">
                      <v-card-title>
                        <h3>Descripción corta</h3>
                      </v-card-title>
                      <v-row>
                        <v-col class="pb-4" cols="8" offset="2">
                          <v-textarea
                            v-model="shortDescription"
                            name="short description"
                            label ="Escribe una descripción de máximo 62 caracteres, para las tarjetas de Messenger."
                            :counter="max1"
                            :rules="[rules.counter1]"
                            multi-line
                            outlined
                          ></v-textarea>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                  <v-row  >
                    <v-col cols="12">
                      <v-card-title>
                        <h3>Descripción larga</h3>
                      </v-card-title>
                      <v-row>
                        <v-col class="pb-4" cols="8" offset="2" >
                          <v-textarea
                            v-model="longDescription"
                            name="large description"
                            label="Escribe una descripción larga del producto para la vista web."
                            :counter="max2"
                            :rules="[rules.counter2]"
                            multi-line
                            outlined
                          ></v-textarea>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>
            </v-row>
            <v-row class="mb-5" v-show="useImagesForVariations">
              <v-col>
                <v-card>
                  <v-card-title>
                    <h3>Imagen principal</h3>
                  </v-card-title>
                  <v-row class="col mt-4 pb-5" >
                    <v-col cols="6" offset="3">
                      <v-tooltip
                        bottom
                      >
                        <template v-slot:activator="{on}">
                          <v-img
                            @click="loadImage('main')"
                            :src="imageUrl === '' ? addImageIcon : imageUrl"
                            height="250"
                            contain
                            style="cursor:pointer"
                            v-on="on"
                            eager
                          />
                        </template>
                        <span>{{imageUrl === '' ? 'Agregar imagen' : 'Cambiar imagen'}}</span>
                      </v-tooltip>
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>
            </v-row>
            <v-row class="mb-5" v-show="useImagesForVariations">
              <v-col>
                <v-card>
                  <v-card-title>
                    <h3>Galería principal de imágenes</h3>
                  </v-card-title>
                  <v-row class="ml-5 mr-5 mb-5">
                    <template>
                      <gallery
                        :gallery="gallery"
                        :rules="rules"
                        :max1="max1"
                        :max3="max3"
                        :companyId="companyId"
                      />
                    </template>
                  </v-row>
                </v-card>
              </v-col>
            </v-row>
            <v-row class="mb-5" >
              <v-col>
                <v-card>
                  <v-card-title>
                    <h3>Video de presentación</h3>
                  </v-card-title>
                  <v-row class="mt-4 pb-5">
                    <v-col cols="6" offset="3">
                      <v-tooltip
                        bottom
                      >
                        <template v-slot:activator="{on}">
                          <v-row v-on="on" justify="center">
                          <v-img
                            v-show="videoUrl === ''"
                            @click="loadVideo()"
                            :src="addVideoIcon"
                            height="250"
                            contain
                            style="cursor:pointer"
                            eager
                          />
                          <video
                            v-show="videoUrl !== ''"
                            @click="loadVideo()"
                            :src="videoUrl"
                            height="250"
                            style="cursor:pointer"
                            preload="metadata"
                            controls
                          ></video>
                          </v-row>
                        </template>
                        <span>{{videoUrl === '' ? 'Agregar video' : 'Cambiar video'}}</span>
                      </v-tooltip>
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>
            </v-row>
            <!-- <v-row class="mb-5" >
              <v-col>
                <v-card>
                  <v-card-title>
                    <h3>PDF Link</h3>
                  </v-card-title>
                  <v-row class="pa-4" >
                    <v-col>
                      <v-text-field
                        v-model="pdfUrl"
                        name="pdfUrl"
                        id="pdfUrl"
                        :counter="max2"
                        :rules="[rules.counter2]"
                        type="text"
                        filled
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>
            </v-row> -->
            <v-row class="mb-5">
              <v-col>
                <v-card>
                  <v-card-title>
                    <h3>Datos del producto</h3>
                  </v-card-title>
                  <v-col class="mt-4" cols="10" offset="1" >
                    <h3>Moneda</h3>
                    <v-row class="mb-3" >
                      <v-col>
                        <v-radio-group v-model="meta.currency" :mandatory="true" row class="ml-5">
                          <v-radio label="USD" value="USD"></v-radio>
                          <v-radio label="Bs" value="Bs"></v-radio>
                        </v-radio-group>
                      </v-col>
                    </v-row>
                    <h3 v-show="!hasVariations">General</h3>
                    <v-row class="mb-5" v-show="!hasVariations">
                      <v-col cols="6">
                        <v-col class="mt-4" cols="12" >
                          <v-text-field
                            name="sku"
                            label="SKU"
                            id="sku"
                            v-model="meta.sku"
                            class="pr-5 pl-5"
                            type="text"
                            :disabled="attributes[0].name !== '' ? true : false"
                          ></v-text-field>
                        </v-col>
                        <v-col class="mt-4" cols="12" >
                          <v-text-field
                            name="barcode"
                            label="Código de barras"
                            id="barcode"
                            v-model="meta.barcode"
                            class="pr-5 pl-5"
                            type="text"
                            :disabled="attributes[0].name !== '' ? true : false"
                          ></v-text-field>
                        </v-col>
                        <v-col class="mt-4" cols="12" >
                          <v-text-field
                            name="regularPrice"
                            label="Precio regular"
                            id="regularPrice"
                            v-model="meta.regularPrice"
                            class="pr-5 pl-5"
                            :prefix="meta.currency"
                            type="number"
                            :disabled="attributes[0].name !== '' ? true : false"
                            @change="normalizeNumber('RP', -1)"
                          ></v-text-field>
                        </v-col>
                        <v-col class="mt-4" cols="12" >
                          <v-text-field
                            name="salePrice"
                            label="Precio de venta"
                            id="salePrice"
                            v-model="meta.salePrice"
                            class="pr-5 pl-5"
                            :prefix="meta.currency"
                            type="number"
                            :disabled="attributes[0].name !== '' ? true : false"
                            @change="normalizeNumber('SP', -1)"
                          ></v-text-field>
                        </v-col>
                      </v-col>
                      <v-col cols="6">
                        <v-col class="mt-4" cols="12" >
                          <v-text-field
                            name="weight"
                            label="Peso"
                            id="weight"
                            v-model="meta.weight"
                            class="pr-5 pl-5"
                            prefix="Kg"
                            type="number"
                            :disabled="attributes[0].name !== '' ? true : false"
                          ></v-text-field>
                        </v-col>
                        <v-col class="mt-4" cols="12" >
                          <v-text-field
                            name="length"
                            label="Largo"
                            id="length"
                            v-model="meta.length"
                            class="pr-5 pl-5"
                            prefix="cm"
                            type="number"
                            :disabled="attributes[0].name !== '' ? true : false"
                          ></v-text-field>
                        </v-col>
                        <v-col class="mt-4" cols="12" >
                          <v-text-field
                            name="width"
                            label="Ancho"
                            id="width"
                            v-model="meta.width"
                            class="pr-5 pl-5"
                            prefix="cm"
                            type="number"
                            :disabled="attributes[0].name !== '' ? true : false"
                          ></v-text-field>
                        </v-col>
                        <v-col class="mt-4" cols="12" >
                          <v-text-field
                            name="height"
                            label="Alto"
                            id="height"
                            v-model="meta.height"
                            class="pr-5 pl-5"
                            prefix="cm"
                            type="number"
                            :disabled="attributes[0].name !== '' ? true : false"
                          ></v-text-field>
                        </v-col>
                      </v-col>
                    </v-row>
                    <h3 v-show="!hasVariations">Inventario</h3>
                    <v-row class="mb-4" v-show="!hasVariations">
                      <v-col cols="12">
                        <v-col class="mt-4" cols="4" >
                          <v-text-field
                            :disabled="attributes[0].name !== '' ? true : false"
                            name="stock"
                            label="Stock"
                            id="stock"
                            v-model="meta.stock"
                            class="pr-5 pl-5 mb-3"
                            @change="normalizeNumber('STK', -1)"
                          ></v-text-field>
                          <p class="pr-5 pl-5">Estado del stock:</p>
                          <v-radio-group
                            v-model="meta.stockStatus"
                            :mandatory="false"
                            :disabled="attributes[0].name !== '' ? true : false"
                            class="pr-5 pl-5"
                          >
                            <v-radio label="Disponible" value="available"></v-radio>
                            <v-radio label="En espera" value="on_hold"></v-radio>
                          </v-radio-group>
                        </v-col>
                      </v-col>
                    </v-row>
                    <v-row class="mb-5">
                      <v-col cols="12">
                        <v-row>
                          <v-col cols="12">
                            <h3>Características del producto</h3>
                            <p class="body-2">Agrega las características del producto, ej. "Tela: 70 % algodón y 30 % poliester, lavar a mano, secar en la sambro y usar plancha tibia."</p>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="8" offset="2">
                            <v-content
                              v-for="(feature, index) in features"
                              :key="index"
                              class="pa-0"
                            >
                              <v-row style="position: relative;">
                                <v-col cols="12">
                                  <v-row class="pb-4 pt-7" :style="{borderBottom:style.border}">
                                    <v-col cols="4">
                                      <v-text-field
                                        v-model="feature.name"
                                        label="Característica"
                                      ></v-text-field>
                                    </v-col>
                                    <v-col cols="8">
                                      <v-textarea
                                        v-model="feature.value"
                                        label="Detalle"
                                        multi-line
                                      ></v-textarea>
                                    </v-col>
                                  </v-row>
                                  <v-tooltip bottom v-if="features[0].name !== '' && features[0].value !== ''">
                                    <template v-slot:activator="{on}">
                                      <v-btn
                                        @click="deleteFeature(index)"
                                        v-on="on"
                                        dark
                                        fab
                                        small
                                        absolute
                                        icon
                                        color="grey"
                                        style="right: -40px; top: 40px"
                                      >
                                        <v-icon>{{deleteIcon}}</v-icon>
                                      </v-btn>
                                    </template>
                                    <span>Eliminar característica</span>
                                  </v-tooltip>
                                  <v-row justify="center" v-show="index + 1 === features.length">
                                    <v-tooltip bottom>
                                      <template v-slot:activator="{on}">
                                        <v-btn
                                          @click="addFeature(index)"
                                          dark
                                          fab
                                          small
                                          icon
                                          :color="mainColor"
                                          v-on="on"
                                          large
                                        >
                                          <v-icon>{{addIcon}}</v-icon>
                                        </v-btn>
                                      </template>
                                      <span>Agregar característica</span>
                                    </v-tooltip>
                                  </v-row>
                                </v-col>
                              </v-row>
                            </v-content>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-card>
              </v-col>
            </v-row>
            <!-- <v-row  >
              <v-col class="mb-5" cols="12" >
                <v-card>
                  <v-card-title>
                    <h3>Productos relacionados</h3>
                  </v-card-title>
                  <p>Cross-sells</p>
                </v-card>
              </v-col>
            </v-row> -->
            <v-row class="pb-5" v-show="hasVariations">
              <v-col cols="12">
                <v-card>
                  <v-card-title>
                    <h3>Variaciones</h3>
                  </v-card-title>
                  <v-card-text>
                    <p
                      v-if="!showVariations && attributes[0].name === ''"
                    >* Este producto aún no tiene variaciones.</p>
                  </v-card-text>
                  <v-row   class="text-center">
                    <v-col>
                        <v-btn
                          v-if="!showVariations && attributes[0].name === ''"
                          @click="showVariations = !showVariations"
                          :color="mainColor"
                          outlined
                        >Crear variación</v-btn>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="8" offset="2" class="pb-10">
                      <v-content
                        v-for="(attribute, index) in attributes"
                        :key="index"
                        class="pt-3 pl-0 pb-10"
                      >
                        <v-row  v-if="showVariations || attributes[0].name !== ''">
                          <v-col cols="12">
                            <v-row>
                              <h3>Atributo {{index + 1}}</h3>
                            </v-row>
                            <v-row style="position: relative;">
                              <v-col cols="12" >
                                <v-text-field
                                  v-model="attribute.name"
                                  name="attributeName"
                                  label="Nombre del atributo, Ej. color "
                                ></v-text-field>
                                <v-combobox
                                  v-model="attribute.variations"
                                  hide-selected
                                  hint="Agrega variaciones como ser rojo, verde, grande, etc."
                                  label="Escribe la variación y preciona enter"
                                  multiple
                                  persistent-hint
                                  small-chips
                                  deletable-chips
                                  @change="addRemVariations(index)"
                                  class="mt-7 pb-4"
                                ></v-combobox>
                              </v-col>
                              <v-row>
                                <v-col>
                                  <v-card-text>
                                      <h3>Mostrar imagen en vista web</h3>
                                      <p>¿Quieres que aparezca la imagen en la selección de variación de la vista web del bot o sólo texto?</p>
                                  </v-card-text>
                                  <v-switch
                                      v-model="attribute.showImageOnWeb"
                                      label="Mostrar imagen"
                                      class="pl-5"
                                  ></v-switch>
                                </v-col>
                                <v-col v-show="attribute.showImageOnWeb">
                                  <template>
                                    <add-variation-image
                                      :varImages="attribute.variationsImages"
                                      :companyId="companyId"
                                    />
                                  </template>
                                </v-col>
                              </v-row>
                              <v-btn
                                @click="removeAttributeBlock(index)"
                                dark
                                fab
                                small
                                absolute
                                icon
                                color="grey"
                                style="right: -40px;"
                              >
                                <v-icon>{{deleteIcon}}</v-icon>
                              </v-btn>
                            </v-row>
                            <v-row justify="center" class="pt-10">
                              <v-tooltip bottom v-if="index + 1 === attributes.length">
                                <template v-slot:activator="{on}">
                                  <v-btn
                                    @click="addAttributeBlock(index)"
                                    dark
                                    fab
                                    small
                                    icon
                                    :color="mainColor"
                                    v-on="on"
                                    x-large
                                  >
                                    <v-icon>{{addIcon}}</v-icon>
                                  </v-btn>
                                </template>
                                <span>Agregar atributo</span>
                              </v-tooltip>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-content>
                    </v-col>
                  </v-row>
                  <v-row
                    v-if="attributes[0].name !== '' && attributes[0].variations[0] !== undefined"
                  >
                    <v-col class="pt-10 pl-0" cols="8" offset="2" :style="`border-top:${style.border}`" >
                      <h3>Agregar datos a las variaciones</h3>
                      <p>Puedes combinar las variaciones de distintas maneras, ej. grande-azul</p>
                    </v-col>
                  </v-row>
                  <v-content v-for="(variation, index) in variations" :key="index" class="pt-1 pl-0">
                    <v-row >
                      <v-col>
                        <v-row>
                          <v-col cols="8" offset="2">
                            <v-row  >
                              <v-col cols="3" class="mr-4">
                                <v-select
                                  v-if="attributes.length >= 1 && attributes[0].name !== '' && attributes[0].variations[0] !== undefined"
                                  v-model="selectedVariations.v1[index]"
                                  :items="attributes[0].variationsSelect"
                                  :label="'Elige ' + attributes[0].name"
                                  id="selectedVariations1"
                                  @change="setVariationName(index)"
                                ></v-select>
                              </v-col>
                              <v-col cols="3" class="mr-4">
                                <v-select
                                  v-if="attributes.length >= 2 && attributes[1].name !== '' && attributes[1].variations[0] !== undefined"
                                  v-model="selectedVariations.v2[index]"
                                  :items="attributes[1].variationsSelect"
                                  :label="'Elige ' + attributes[1].name"
                                  id="selectedVariations2"
                                  @change="setVariationName(index)"
                                ></v-select>
                              </v-col>
                              <v-col cols="3" class="mr-4">
                                <v-select
                                  v-if="attributes.length >= 3 && attributes[2].name !== '' && attributes[2].variations[0] !== undefined"
                                  v-model="selectedVariations.v3[index]"
                                  :items="attributes[2].variationsSelect"
                                  :label="'Elige ' + attributes[2].name"
                                  id="selectedVariations3"
                                  @change="setVariationName(index)"
                                ></v-select>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col cols="3" class="mr-4">
                                <v-select
                                  v-if="attributes.length >= 4 && attributes[3].name !== '' && attributes[3].variations[0] !== undefined"
                                  v-model="selectedVariations.v4[index]"
                                  :items="attributes[3].variationsSelect"
                                  :label="'Elige ' + attributes[3].name"
                                  id="selectedVariations4"
                                  @change="setVariationName(index)"
                                ></v-select>
                              </v-col>
                              <v-col cols="3" class="mr-4">
                                <v-select
                                  v-if="attributes.length >= 5 && attributes[4].name !== '' && attributes[4].variations[0] !== undefined"
                                  v-model="selectedVariations.v5[index]"
                                  :items="attributes[4].variationsSelect"
                                  :label="'Elige ' + attributes[4].name"
                                  id="selectedVariations5"
                                  @change="setVariationName(index)"
                                ></v-select>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                        <v-row style="position: relative;">
                          <v-col class="pt-5" cols="10" offset="1" v-if="variation.name !== ''">
                            <v-expansion-panels focusable>
                              <v-expansion-panel :key="index">
                                <v-expansion-panel-header>{{variation.name}}</v-expansion-panel-header>
                                <v-expansion-panel-content>
                                  <v-card flat class="mt-4">
                                      <h3 v-show="!useImagesForVariations">Imagen principal de variación</h3>
                                      <v-row class="mt-4 pb-5" v-show="!useImagesForVariations">
                                        <v-col cols="6" offset="3">
                                          <v-tooltip bottom>
                                            <template v-slot:activator="{on}">
                                              <v-img
                                                @click="loadImage('variation', index)"
                                                :src="variation.imageUrl === '' ? addImageIcon : variation.imageUrl"
                                                height="200"
                                                contain
                                                style="cursor:pointer"
                                                v-on="on"
                                                eager
                                              />
                                            </template>
                                            <span>{{variation.imageUrl === '' ? 'Agregar imagen' : 'Cambiar imagen'}}</span>
                                          </v-tooltip>
                                        </v-col>
                                      </v-row>
                                      <v-row class="mb-5" v-show="!useImagesForVariations">
                                      <v-col>
                                        <h3>Galería de imágenes</h3>
                                        <template>
                                          <gallery
                                            :gallery="variation.gallery"
                                            :rules="rules"
                                            :max1="max1"
                                            :max3="max3"
                                            :companyId="companyId"
                                          />
                                        </template>
                                      </v-col>
                                    </v-row>
                                      <h3>Datos generales</h3>
                                      <v-row class="mb-4">
                                        <v-col cols="6">
                                          <v-col cols="12" class="mt-4">
                                            <v-text-field
                                              name="sku"
                                              label="SKU"
                                              id="sku"
                                              v-model="variation.meta.sku"
                                              class="pr-5 pl-5"
                                            ></v-text-field>
                                          </v-col>
                                          <v-col cols="12" class="mt-4">
                                            <v-text-field
                                              name="barcode"
                                              label="Código de barras"
                                              id="barcode"
                                              v-model="variation.meta.barcode"
                                              class="pr-5 pl-5"
                                            ></v-text-field>
                                          </v-col>
                                          <v-col cols="12" class="mt-4">
                                            <v-text-field
                                              name="regularPrice"
                                              label="Precio regular"
                                              id="regularPrice"
                                              v-model="variation.meta.regularPrice"
                                              class="pr-5 pl-5"
                                              :prefix="meta.currency"
                                              type="number"
                                              @change="normalizeNumber('RP', index)"
                                            ></v-text-field>
                                          </v-col>
                                          <v-col cols="12" class="mt-4">
                                            <v-text-field
                                              name="salePrice"
                                              label="Precio de venta"
                                              id="salePrice"
                                              v-model="variation.meta.salePrice"
                                              class="pr-5 pl-5"
                                              :prefix="meta.currency"
                                              type="number"
                                              @change="normalizeNumber('SP', index)"
                                            ></v-text-field>
                                          </v-col>
                                        </v-col>
                                        <v-col cols="6">
                                          <v-col cols="12" class="mt-4">
                                            <v-text-field
                                              name="weight"
                                              label="Peso"
                                              id="weight"
                                              v-model="variation.meta.weight"
                                              class="pr-5 pl-5"
                                              prefix="Kg"
                                              type="number"
                                            ></v-text-field>
                                          </v-col>
                                          <v-col cols="12" class="mt-4">
                                            <v-text-field
                                              name="length"
                                              label="Largo"
                                              id="length"
                                              v-model="variation.meta.length"
                                              class="pr-5 pl-5"
                                              prefix="cm"
                                              type="number"
                                            ></v-text-field>
                                          </v-col>
                                          <v-col cols="12" class="mt-4">
                                            <v-text-field
                                              name="width"
                                              label="Ancho"
                                              id="width"
                                              v-model="variation.meta.width"
                                              class="pr-5 pl-5"
                                              prefix="cm"
                                              type="number"
                                            ></v-text-field>
                                          </v-col>
                                          <v-col cols="12" class="mt-4">
                                            <v-text-field
                                              name="height"
                                              label="Alto"
                                              id="height"
                                              v-model="variation.meta.height"
                                              class="pr-5 pl-5"
                                              prefix="cm"
                                              type="number"
                                            ></v-text-field>
                                          </v-col>
                                        </v-col>
                                      </v-row>
                                      <h3>Inventario</h3>
                                      <v-row  >
                                        <v-col cols="12" class="mt-3">
                                          <v-col cols="6">
                                            <v-text-field
                                              name="stock"
                                              label="Stock"
                                              id="stock"
                                              v-model="variation.meta.stock"
                                              class="pr-5 pl-5 mb-3"
                                              @change="normalizeNumber('STK', index)"
                                            ></v-text-field>
                                            <p class="pr-5 pl-5">Estado del stock:</p>
                                            <v-radio-group
                                              v-model="variation.meta.stockStatus"
                                              :mandatory="false"
                                              class="pr-5 pl-5"
                                            >
                                              <v-radio label="Disponible" value="available"></v-radio>
                                              <v-radio label="En espera" value="on_hold"></v-radio>
                                            </v-radio-group>
                                          </v-col>
                                        </v-col>
                                      </v-row>
                                      <v-row  >
                                        <v-col cols="12" class="mt-4">
                                          <h3>Descripción</h3>
                                          <v-col cols="10" offset="1" class="mt-4">
                                            <v-textarea
                                              name="variationDescription"
                                              id="variationDescription"
                                              label="Introduce una descripción que caracterice a la variación. (opcional)"
                                              multi-line
                                              v-model="variation.meta.variationDescription"
                                              outlined
                                            ></v-textarea>
                                          </v-col>
                                        </v-col>
                                      </v-row>
                                  </v-card>
                                </v-expansion-panel-content>
                              </v-expansion-panel>
                            </v-expansion-panels>
                          </v-col>
                          <v-btn
                            v-if="variation.name !== ''"
                            @click="removeVariationDataBLock(index)"
                            dark
                            fab
                            small
                            icon
                            color="grey"
                            absolute
                            style="right: 40px"
                          >
                            <v-icon>{{deleteIcon}}</v-icon>
                          </v-btn>
                        </v-row>
                      </v-col>
                    </v-row>
                    <v-row class="pb-8 pt-4" justify="center">
                        <v-tooltip bottom v-if="variation.name !== ''">
                          <template v-slot:activator="{on}">
                            <v-btn
                              @click="addVariationDataBLock(index)"
                              dark
                              fab
                              small
                              icon
                              :color="mainColor"
                              v-on="on"
                            >
                              <v-icon>{{addIcon}}</v-icon>
                            </v-btn>
                          </template>
                          <span>Agregar variación</span>
                        </v-tooltip>
                    </v-row>
                    <v-row class="pb-4 pt-10" >
                      <v-col cols="6" offset="3">
                        <v-select
                          v-if="variation.name !== '' && (index + 1) === variations.length"
                          v-model="variationsDefault"
                          :items="selectVariationDefault"
                          label="Elige la variación por defecto del producto"
                          id="variationDefault"
                          class="pt-5"
                        ></v-select>
                      </v-col>
                    </v-row>
                  </v-content>
                </v-card>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-card>
                  <v-card-title>
                    <h3>Preguntas frecuentes</h3>
                  </v-card-title>
                  <v-card-text>
                    <p>En esta sección podrás agregar información extra referente al producto en cuestión,  como instruccines de uso.</p>
                  </v-card-text>
                  <template>
                    <flow-components
                      :flowComponents="flowComponents"
                      :rules="rules"
                      :max1="max1"
                      :max2="max2"
                      :max3="max3"
                      :companyId="companyId"
                    />
                  </template>
                </v-card>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="text-right pa-0" cols="12" >
                <v-btn
                  type="submit"
                  :disabled="onLoading"
                  dark
                  :color="mainColor"
                  small
                  style="position: fixed; top: 65px; right: 15px;"
                >
                  Guardar
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-col>
      </v-row>
    </v-container>
  </v-content>
</template>
<script>
/* eslint-disable no-console */
import * as util from '../../util'
import * as constants from '../../../constants.json'
import { mdiPlusCircle, mdiDeleteOutline, mdiCached } from '@mdi/js'

export default {
  props: ['companyId'],
  data () {
    return {
      productName: '', // The product name.
      alterName1: '', // Alternative product name.
      alterName2: '', // Alternative product name.
      status: 'Borrador', // The prouct status: draft, published, down.
      shortDescription: '', // A short description of the product. Max  caracter: 80.
      longDescription: '', // A long description of the product. Max  caracter: 1500.
      imageUrl: '',
      videoUrl: '',
      gallery: [
        {
          imageUrl: ''
        }
      ],
      flowComponents: [ // The knowledge base of the porduct.
        {
          selectContentType: '', // Type of the content: description, image, video or gallery.
          title: '',
          description: '',
          gallery: [
            {
              imageUrl: '',
              title: '',
              subtitle: ''
            }
          ],
          keywords: [],
          imageUrl: '',
          videoUrl: '',
          showOnWeb: false
        }
      ],
      attributes: [ // All the attributes created of the product e.g. color, size.
        {
          name: '', // The atttribute's name e.g. color.
          variations: [], // The variation's name selected e.g. blue .
          variationsSelect: ['Ninguno'], // The variation's name to be selected e.g blue, red and green.
          showImageOnWeb: false, // If true show an image insted of text in web view's select variation.
          variationsImages: [{
            name: '',
            imageUrl: ''
          }]
        }
      ],
      variations: [ // The product's variations.
        {
          attributes: [], // The attributes that corresponde to the variation.
          name: '', // The variation's name. It's assigned automatically, depending on the chosen variation.
          title: '',
          gallery: [
            {
              imageUrl: ''
            }
          ],
          productId: '',
          type: 'variation',
          imageUrl: '',
          keywords: [], // This keywords are assigned automatically and correspond to the chosen variation.
          meta: { // The meta values of the variation.
            sku: '',
            barcode: '',
            regularPrice: 0,
            salePrice: 0,
            weight: '',
            length: '',
            width: '',
            height: '',
            stock: 0,
            stockStatus: '',
            variationDescription: ''
          },
          id: ''
        }
      ],
      variationsDefault: '', // The variation that represents the product.
      meta: { // The meta values of the product.
        sku: '',
        barcode: '',
        regularPrice: 0,
        salePrice: 0,
        weight: '',
        length: '',
        width: '',
        height: '',
        stock: 0,
        stockStatus: '',
        currency: 'Bs'
      },
      features: [{ name: '', value: '' }], // The product's features.
      categories: [], // All the categories ids related to the product. They are assigned when the parent's categories are chosen.
      parentCategories: [{ name: '', id: '' }], // The parent categories of the product.
      pdfUrl: '', // Pdf document link.
      keywords: [], // String values that represent the main characteristics of the product, some values are autogenerated.
      hasVariations: false,
      useImagesForVariations: true,
      selectedVariations: { // This map keeps the variations selected.
        // only cms
        v1: [],
        v2: [],
        v3: [],
        v4: [],
        v5: []
      },
      // ---------------------------------------------
      selectedCategoryNames: [{ name: null }], // This array keeps the parent categories names selected.
      categoriesMap: [], // Aux that helps generate the categories select values.
      selectCategories: ['Ninguno'], // Array of categories names to be selected as parent categories.
      statusChanged: false, // // A flag that indicates the status has been changed.
      statusSelect: ['Borrador', 'Publicado', 'Baja'], // Status values to be selected.
      categoriesNames: {}, // A map containing all the category's names. categoryId: categoryName.
      relationshipsMap: {}, // A map containing all the relationships between categories.
      formerParentId: '', // The former parent id when the parentIs has been changed.
      creationDate: '', // The date when the document has been created.
      showVariations: false, // Flag, if false we hide the variation component.
      pickFile: { index: null, zone: null }, // Auxiliar index to poit to the actual content block that uploads new content (images, videos).
      max1: 61, // Short description Max character allowed in messenger card subtitle.
      max2: 1500, // Flow text, Max character allowed in messenger.
      max3: 80, // Max character allowed in messenger card title.
      mainColor: constants.MAINCOLOR,
      style: {
        border: '1px solid #e1e1e1',
        fontColor: '#606060'
      },
      errors: [], // The user's errors.
      addImageIcon: constants.ADD_IMAGE_ICON,
      addVideoIcon: constants.ADD_VIDEO_ICON,
      LoadImageDialogProps: { // Properties to be sent to the LoadImageDialog component.
        loadDialog: false,
        imageUrl: null
      },
      LoadVideoDialogProps: { // Properties to be sent to the LoadVideoDialog component.
        loadDialog: false,
        videoUrl: null
      },
      addIcon: mdiPlusCircle,
      deleteIcon: mdiDeleteOutline,
      cacheIcon: mdiCached,
      // --------------------------------------------
      rules: {
        counter1: value =>
          (value || '').length <= this.max1 ||
          `Sólo se permite un máximo de ${this.max1} caracteres`,
        counter2: value =>
          (value || '').length <= this.max2 ||
          `Sólo se permite un máximo de ${this.max2} caracteres`,
        counter3: value =>
          (value || '').length <= this.max3 ||
          `Sólo se permite un máximo de ${this.max3} caracteres`,
        required: value => !!value || 'Requerido.',
        hasName: value => value !== 'Ninguno' || 'Elige nombre'
      }
    }
  },

  computed: {
    /**
     * Show the Loading animation.
     */
    onLoading () {
      return this.$store.getters.getLoading
    },

    /**
     * Computed method that load all the variation's names to be selected.
     * @returns an array with all the variations names.
     */
    selectVariationDefault () {
      let variationsName = []
      this.variations.forEach(el => {
        variationsName.push(el.name)
      })

      console.log('this.variations', this.variations)
      return variationsName
    },

    /**
     * Get user object.
     * @returns the user object.
     */
    user () {
      return this.$store.getters.getUser
    },

    /**
     * Verify if the user is authenticated.
     * @returns true if user is authenticated.
     */
    userIsAuthenticated () {
      return (
        this.$store.getters.getUser !== null &&
        this.$store.getters.getUser !== undefined
      )
    },

    /**
     * Return the stock
     */
    productStock () {
      let stock = 0
      if (this.hasVariations) {
        this.variations.forEach(variation => {
          stock = stock + variation.meta.stock
        })
      } else {
        stock = this.meta.stock
      }
      console.log('stock: ', stock)
      return stock
    }
  },

  watch: {
    /**
     * If no user exists we load the main view.
     */
    user (value) {
      if (value === null || value === undefined) {
        this.$router.push('/')
      }
    },

    /**
     * If a new image has been loaded we add it to the correspondent property.
     */
    'LoadImageDialogProps.imageUrl': function (val) {
      if (this.pickFile.zone === 'main') {
        this.imageUrl = this.LoadImageDialogProps.imageUrl
      } else if (this.pickFile.zone === 'variation') {
        this.variations[this.pickFile.index1].imageUrl = this.LoadImageDialogProps.imageUrl
      }
    },

    /**
     * If a new video has been loaded we add it to the correspondent property.
     */
    'LoadVideoDialogProps.videoUrl': function (val) {
      this.videoUrl = this.LoadVideoDialogProps.videoUrl
    },

    /**
     * Adding keywords to variations
     */
    keywords (newKeywords, oldKeywords) {
      console.log('newKeywords', newKeywords)
      console.log('oldKeywords', oldKeywords)

      this.variations.forEach(variation => {
        if (variation.name !== '') {
          // Delete keywords
          for (const oldKeyword of oldKeywords) {
            const index = variation.keywords.findIndex(varKeyword => varKeyword === oldKeyword)
            if (index !== -1) {
              variation.keywords.splice(index, 1)
            }
          }
          console.log('variation.keywords: ', [...variation.keywords])

          // Push keywords
          for (const newKeyword of newKeywords) {
            if (variation.keywords.findIndex(varKeyword => varKeyword === newKeyword) === -1) { // The keyword doens't exist
              variation.keywords.push(newKeyword)
            }
          }
          console.log('variation.keywords: ', [...variation.keywords])
        }
      })
    }
  },

  /**
   * Create view and observe data
   */
  async created () {
    // Fetching the data when the view is created and the data is already being observed
    await this.fetchData()
  },

  methods: {
    /**
     * Fetch data
     */
    async fetchData () {
      try {
        // Creating category selector.
        await this.$store.dispatch('actionsLoadRelationshipsMap', {
          companyId: this.companyId
        })
        this.relationshipsMap = this.$store.getters.getRelationShipsMap
        this.categoriesNames = this.$store.getters.getCategoriesNames

        console.log('relationshipsMap', this.relationshipsMap)

        // Generate the category map.
        if (!util.objIsEmpty(this.relationshipsMap)) {
          let categoryMap = util.generateCategoryMap(this.relationshipsMap, this.categoriesNames, this.id)

          // Generate the category selector from the category map.
          const catMapArr = []
          util.generateCategorySelector(categoryMap, catMapArr)
          this.categoriesMap = catMapArr
          this.categoriesMap.forEach(el => {
            this.selectCategories.push(el.name)
          })
        }

        // Loading media
        await this.$store.dispatch('actionLoadMedia', {
          companyId: this.companyId
        })
      } catch (error) {
        alert(error)
        throw error
      }
    },

    /**
     * Create product
     */
    async onCreateProduct () {
      console.log('status: ', this.status)
      const variationsEmpty = [{
        attributes: [],
        name: '',
        title: '',
        gallery: [
          {
            imageUrl: ''
          }
        ],
        productId: '',
        type: 'variation',
        imageUrl: '',
        keywords: [],
        meta: {
          sku: '',
          barcode: '',
          regularPrice: 0,
          salePrice: 0,
          weight: '',
          length: '',
          width: '',
          height: '',
          stock: 0,
          stockStatus: '',
          variationDescription: ''
        },
        id: ''
      }]

      const productData = {
        productName: this.productName,
        alterName1: this.alterName1,
        alterName2: this.alterName2,
        status: '',
        statusChanged: this.statusChanged,
        shortDescription: this.shortDescription,
        longDescription: this.longDescription,
        imageUrl: this.imageUrl,
        videoUrl: this.videoUrl,
        pdfUrl: this.pdfUrl,
        gallery: [...this.gallery],
        flowComponents: [...this.flowComponents],
        attributes: [...this.attributes],
        variations: this.hasVariations === true ? [...this.variations] : variationsEmpty,
        variationsDefault: this.variationsDefault,
        meta: {
          sku: this.meta.sku,
          barcode: this.meta.barcode,
          regularPrice: this.meta.regularPrice,
          salePrice: this.meta.salePrice,
          weight: this.meta.weight,
          length: this.meta.length,
          width: this.meta.weight,
          height: this.meta.height,
          stock: this.meta.stock,
          stockStatus: this.meta.stockStatus,
          currency: this.meta.currency
        },
        parentCategories: [],
        categories: this.categories,
        features: this.features,
        keywords: this.keywords,
        selectedVariations: this.selectedVariations,
        creationDate: new Date(),
        modificationDate: '',
        hasVariations: this.hasVariations,
        useImagesForVariations: this.useImagesForVariations,
        companyId: this.companyId
      }
      this.status === 'Borrador' ? productData.status = 'draft' : this.status === 'Publicado' ? productData.status = 'published' : productData.status = 'down'

      if (this.parentCategories.length > 1) {
        if (this.parentCategories[this.parentCategories.length - 1].id === '') {
          this.parentCategories.pop()
        }
      }
      productData.parentCategories = this.parentCategories

      // If there are any errors we show an alert
      if (this.errors.length > 0) {
        console.log(this.errors)
        alert(`Tienes errores que corregir: ${this.errors}`)
      } else if (this.parentCategories[0].id === '') {
        alert('Elige al menos una categoría')
      } else if (this.hasVariations && this.variationsDefault === '') {
        alert('Elige la variación por defecto del producto')
      } else {
        try {
          console.log('productData: ', productData)
          this.loadedProduct = await this.$store.dispatch('actionCreateUpdateProduct', productData)

          console.log('this.loadedProduct: ', this.loadedProduct)
          if (!this.onLoading) {
            this.$router.push({
              name: 'EditProduct',
              params: {
                companyId: this.companyId,
                id: this.loadedProduct.productId
              }
            })
          }
        } catch (error) {
          alert(error)
          throw error
        }
      }
    },

    /**
     * Adding new attribute block
     */
    addAttributeBlock () {
      console.log(this.attributes[0].variations.length)
      // Don't add anything if there is an empty attribute block
      let checkEmptyContent = this.attributes.filter(
        attribute => attribute.name === ''
      )
      if (checkEmptyContent.length >= 1 && this.attributes.length > 0) return

      // Pushing the elements to attributes
      this.attributes.push({
        name: '',
        variations: [],
        variationsSelect: ['Ninguno'],
        showImageOnWeb: false,
        variationsImages: [{
          name: '',
          imageUrl: ''
        }]
      })
    },

    /**
     * Adding variations to attributes
     */
    addRemVariations (index) {
      // Retrieving the deleted item
      let deletedVariationName = ''
      let newVariationName = ''

      console.log(`this.attributes[${index}].variationsSelect:`, [...this.attributes[index].variationsSelect])

      console.log(`this.attributes[${index}]`, this.attributes[index])

      console.log('variations', [...this.variations])

      // Verify if variation's name has been deleted
      for (const key of this.attributes[index].variationsSelect) {
        console.log('key: ', key)
        if (key !== 'Ninguno') {
          if (this.attributes[index].variations.indexOf(key) === -1) {
            deletedVariationName = key
            break
          }
        }
      }
      console.log('deletedVariationName: ', deletedVariationName)

      // Verify if deleted variation name is being used
      if (deletedVariationName !== '') {
        for (const variation of this.variations) {
          if (variation.name.includes(deletedVariationName)) {
            alert('El nombre de variación está en uso, elimina primero la variación para poder eliminar el nombre.')
            this.attributes[index].variations.push(deletedVariationName)
            break
          } else {
            const deletedIndex = this.attributes[index].variationsImages.findIndex(el => el.name === deletedVariationName)
            this.attributes[index].variationsImages.splice(deletedIndex, 1)
          }
        }
      } else {
        // Find new variation's name
        for (const key of this.attributes[index].variations) {
          console.log('key: ', key)
          const i = this.attributes[index].variationsSelect.findIndex(variationName => {
            if ((variationName !== 'Ninguno') && (variationName === key)) return true
          })
          if (i === -1) {
            console.log(`new variation's name`)
            newVariationName = key
            console.log('newVariationName: ', newVariationName)
            break
          }
        }
        // Copying variation's name to variation images array
        if ((this.attributes[index].variationsImages.length === 1) && (this.attributes[index].variationsImages[0].name === '')) {
          this.attributes[index].variationsImages[0].name = newVariationName
        } else {
          this.attributes[index].variationsImages.push({
            name: newVariationName,
            imageUrl: ''
          })
        }
      }

      // Copying the combobox items to variationsSelect
      this.attributes[index].variationsSelect = ['Ninguno']
      if (this.attributes[index].variations.length !== 0) {
        this.attributes[index].variations.forEach(el => {
          this.attributes[index].variationsSelect.push(el)
        })
      } else {
        this.attributes[index].variationsSelect.pop()
      }

      console.log(`this.attributes[${index}].variationsImages:`, [...this.attributes[index].variationsImages])
    },

    /**
     * Set names to variations
     */
    async setVariationName (index) {
      this.variations[index].keywords = []
      this.variations[index].attributes = []

      // Mixing variations name
      let variationName = ''
      let keywords = []
      let attributes = []

      if (this.selectedVariations.v1[index]) {
        if (this.selectedVariations.v1[index] === 'Ninguno') {
          attributes.splice(0, 1)
        } else {
          variationName = variationName + '-' + this.selectedVariations.v1[index]
          attributes.push(this.attributes[0].name)
          keywords.push(this.selectedVariations.v1[index])
        }
      }
      if (this.selectedVariations.v2[index]) {
        if (this.selectedVariations.v2[index] === 'Ninguno') {
          attributes.splice(1, 1)
        } else {
          variationName = variationName + '-' + this.selectedVariations.v2[index]
          attributes.push(this.attributes[1].name)
          keywords.push(this.selectedVariations.v2[index])
        }
      }
      if (this.selectedVariations.v3[index]) {
        if (this.selectedVariations.v3[index] === 'Ninguno') {
          attributes.splice(2, 1)
        } else {
          variationName = variationName + '-' + this.selectedVariations.v3[index]
          attributes.push(this.attributes[2].name)
          keywords.push(this.selectedVariations.v3[index])
        }
      }
      if (this.selectedVariations.v4[index]) {
        if (this.selectedVariations.v4[index] === 'Ninguno') {
          attributes.splice(3, 1)
        } else {
          variationName = variationName + '-' + this.selectedVariations.v4[index]
          attributes.push(this.attributes[3].name)
          keywords.push(this.selectedVariations.v4[index])
        }
      }
      if (this.selectedVariations.v5[index]) {
        if (this.selectedVariations.v5[index] === 'Ninguno') {
          attributes.splice(4, 1)
        } else {
          variationName = variationName + '-' + this.selectedVariations.v5[index]
          attributes.push(this.attributes[4].name)
          keywords.push(this.selectedVariations.v5[index])
        }
      }
      variationName = variationName.replace('-', '')

      console.log('variationName: ', variationName)

      // Verifying that variation's name is not registered yet
      let nameRegistered = false
      for (let item of this.variations) {
        if (variationName === item.name) {
          this.errors.push(
            'Tienes una variación duplicada, selecciona otra combinación'
          )
          alert(
            'La variación ya está registrada, selecciona otra combinación.'
          )
          nameRegistered = true

          await this.$nextTick()
          this.selectedVariations.v1.splice(index, 1)
          this.selectedVariations.v2.splice(index, 1)
          this.selectedVariations.v3.splice(index, 1)
          this.selectedVariations.v4.splice(index, 1)
          this.selectedVariations.v5.splice(index, 1)

          this.variations[index].name = ''
        }
      }

      // If name is not registered we addit to the variation's name and load the attributes and the keywords.
      if (!nameRegistered) {
        this.variations[index].name = variationName
        this.variations[index].attributes = [...attributes]
        this.variations[index].keywords = [...keywords]

        // Add the variation's names to variation's keywords
        this.variations.forEach((variation, index) => {
          if (variation.name !== '') {
            variation.keywords = [...this.keywords]
            // Spliting the names and assigning them as keywords
            const variationNames = variation.name.split('-')
            for (const varName of variationNames) {
              if (variation.keywords.indexOf(varName) === -1) {
                variation.keywords.push(varName)
              }
            }
          }
          console.log('variation.keywords: ', this.variations[index].keywords)
        })

        // Delete the error
        if (this.errors.length > 0) {
          this.errors.splice(
            this.errors.indexOf(
              'Tienes una variación duplicada, selecciona otra combinación'
            ),
            1
          )
        }
      }
    },

    /**
     * Add a new variation data block
     */
    addVariationDataBLock (index) {
      // Don't add anything if all posible variation combinations are taken

      console.log('index ', index)
      if (this.attributes.length === 1) {
        console.log('this.attributes.length === 1')

        console.log(this.attributes[0].variationsSelect)
        if (index >= this.attributes[0].variationsSelect.length - 2) {
          console.log(`${index} >= ${this.attributes[0].variationsSelect.length - 2}`)
          return
        }
      } else if (this.attributes.length === 2) {
        console.log('this.attributes.length === 2', this.attributes[1].variationsSelect.length)
        if (
          index + 1 >=
          (this.attributes[0].variationsSelect.length - 1) *
            (this.attributes[1].variationsSelect.length - 1) +
            this.attributes[0].variationsSelect.length +
            this.attributes[1].variationsSelect.length -
            2
        ) {
          return
        }
      } else if (this.attributes.length === 3) {
        console.log(' this.attributes[2].variationsSelect.length !== 0')
        if (
          index + 1 >=
          (this.attributes[0].variationsSelect.length - 1) *
            (this.attributes[1].variationsSelect.length - 1) *
            (this.attributes[2].variationsSelect.length - 1) +
            this.attributes[0].variationsSelect.length +
            this.attributes[1].variationsSelect.length +
            this.attributes[2].variationsSelect.length -
            3
        ) {
          return
        }
      } else if (this.attributes.length === 4) {
        if (
          index + 1 >=
          (this.attributes[0].variationsSelect.length - 1) *
            (this.attributes[1].variationsSelect.length - 1) *
            (this.attributes[2].variationsSelect.length - 1) *
            (this.attributes[3].variationsSelect.length - 1) +
            this.attributes[0].variationsSelect.length +
            this.attributes[1].variationsSelect.length +
            this.attributes[2].variationsSelect.length +
            this.attributes[3].variationsSelect.length -
            4
        ) {
          return
        }
      } else if (this.attributes.length === 5) {
        if (
          index + 1 >=
          (this.attributes[0].variationsSelect.length - 1) *
            (this.attributes[1].variationsSelect.length - 1) *
            (this.attributes[2].variationsSelect.length - 1) *
            (this.attributes[3].variationsSelect.length - 1) *
            (this.attributes[4].variationsSelect.length - 1) +
            this.attributes[0].variationsSelect.length +
            this.attributes[1].variationsSelect.length +
            this.attributes[2].variationsSelect.length +
            this.attributes[3].variationsSelect.length +
            this.attributes[4].variationsSelect.length -
            5
        ) {
          return
        }
      }

      console.log('variation: ', this.variations)
      this.variations.push({
        attributes: [],
        name: '',
        title: '',
        gallery: [
          {
            imageUrl: ''
          }
        ],
        productId: '',
        type: 'variation',
        imageUrl: this.addImageIcon,
        keywords: [],
        meta: {
          sku: '',
          barcode: '',
          regularPrice: 0,
          salePrice: 0,
          weight: '',
          length: '',
          width: '',
          height: '',
          stock: 0,
          stockStatus: '',
          variationDescription: ''
        },
        id: ''
      })
    },

    /**
     * Remove a variation data block
     */
    removeVariationDataBLock (index) {
      // Deletting variation's keywords in this.keywords
      this.variations[index].keywords.forEach(keyword => {
        if (this.keywords.indexOf(keyword.toLowerCase()) !== -1) {
          this.keywords.splice(this.keywords.indexOf(keyword.toLowerCase()))
        }
      })

      // Removing variation
      if (index === 0 && this.variations.length === 1) {
        this.variations[0].attributes = []
        this.variations[0].name = ''
        this.variations[0].imageUrl = this.addImageIcon
        this.variations[0].keywords = []
        this.variations[0].meta.sku = ''
        this.variations[0].meta.barcode = ''
        this.variations[0].meta.regularPrice = ''
        this.variations[0].meta.salePrice = ''
        this.variations[0].meta.weight = ''
        this.variations[0].meta.length = ''
        this.variations[0].meta.width = ''
        this.variations[0].meta.height = ''
        this.variations[0].meta.stock = ''
        this.variations[0].meta.stockStatus = ''
        this.variations[0].meta.variationDescription = ''

        this.selectedVariations.v1 = []
        this.selectedVariations.v2 = []
        this.selectedVariations.v3 = []
        this.selectedVariations.v4 = []
        this.selectedVariations.v5 = []
      } else {
        this.variations.splice(index, 1)
        this.selectedVariations.v1.splice(index, 1)
        this.selectedVariations.v2.splice(index, 1)
        this.selectedVariations.v3.splice(index, 1)
        this.selectedVariations.v4.splice(index, 1)
        this.selectedVariations.v5.splice(index, 1)
      }
    },

    /**
     * Removing attribute block
     */
    removeAttributeBlock (index) {
      // Deleting all select variations associated to an attribute
      this.selectedVariations[`v${index + 1}`] = []

      console.log(`Deleting selectVariation.v${index + 1}`)

      // Deleting all variations with a deleted attribute
      // Copying the array of objects
      let variations = [...this.variations]

      // Deleting variations items

      console.log('this.attributes: ', this.attributes)
      let deletedItems = 0
      variations.forEach((variation, i) => {
        console.log('variation: ', variation)
        variation.attributes.forEach(attribute => {
          if (attribute === this.attributes[index].name) {
            console.log(`${attribute} es igual a ${this.attributes[index].name}`)
            // Deletting variation's keywords in this.keywords
            this.variations[i].keywords.forEach(keyword => {
              if (this.keywords.indexOf(keyword.toLowerCase()) !== -1) {
                this.keywords.splice(this.keywords.findIndex(keyword.toLowerCase()))
              }
            })

            // Deleting the variation
            if (index === 0) {
              console.log('index = ' + index + 'Deleting item ' + this.variations[0].name)
              this.variations = []
              this.variations.push({
                attributes: [],
                name: '',
                title: '',
                gallery: [
                  {
                    imageUrl: ''
                  }
                ],
                productId: '',
                type: 'variation',
                imageUrl: this.addImageIcon,
                keywords: [],
                meta: {
                  sku: '',
                  barcode: '',
                  regularPrice: 0,
                  salePrice: 0,
                  weight: '',
                  length: '',
                  width: '',
                  height: '',
                  stock: 0,
                  stockStatus: '',
                  variationDescription: ''
                },
                id: ''
              })
            } else {
              console.log('Deleting item ' + this.variations[i - deletedItems].name)
              this.variations.splice(i - deletedItems, 1)
              deletedItems++
            }
          }
        })
      })
      // If this.variations ends with no elements we add an empty one
      if (this.variations.length === 0) {
        this.variations.push({
          attributes: [],
          name: '',
          title: '',
          gallery: [
            {
              imageUrl: ''
            }
          ],
          productId: '',
          type: 'variation',
          imageUrl: this.addImageIcon,
          keywords: [],
          meta: {
            sku: '',
            barcode: '',
            regularPrice: 0,
            salePrice: 0,
            weight: '',
            length: '',
            width: '',
            height: '',
            stock: 0,
            stockStatus: '',
            variationDescription: ''
          },
          id: 0
        })
      }

      console.log('this.variations: ', this.variations)

      // Deleting the attribute
      if (this.attributes.length === 1) {
        console.log('Deleting attribute, index = ' + index)
        this.attributes[0].name = ''
        this.attributes[0].variations = []
        this.attributes[0].variationsSelect = ['Ninguno']
        this.showVariations = false
      } else {
        console.log('Deleting attribute, index = ' + index)
        this.attributes.splice(index, 1)
      }
    },

    /**
     * Assigning categories to "category and keywords arrays"
     */
    async addCategory (index) {
      this.formerParentId = this.parentCategories[index].id
      if (this.selectedCategoryNames[index].name === 'Ninguno') {
        if (index === 0) {
          this.parentCategories[index].id = null
          this.parentCategories[index].name = 'none'

          // Deleting keywords and ids related to categories if the user has changed the parent category
          if (this.keywords.length !== 0 && this.formerParentId) {
            if (this.keywords.indexOf(this.categoriesNames[this.formerParentId].toLowerCase()) !== -1) {
              this.keywords.splice(this.keywords.indexOf(this.categoriesNames[this.formerParentId].toLowerCase()), 1)

              this.variations.forEach(variation => {
                if (variation.keywords.indexOf(this.categoriesNames[this.formerParentId].toLowerCase()) !== -1) {
                  variation.keywords.splice(variation.keywords.indexOf(this.categoriesNames[this.formerParentId].toLowerCase()), 1)
                }
              })
            }
            this.categories.splice(
              this.categories.indexOf(this.formerParentId, 1)
            )

            console.log('formerParentId', this.formerParentId)
            util.deleteCategoriesAndKeywords(
              this.relationshipsMap,
              this.categoriesNames,
              this.formerParentId,
              this.keywords,
              this.categories
            )
          }

          console.log('this.categories', this.categories)

          console.log('this.keywords', this.keywords)
        } else {
          await this.$nextTick()
          this.selectedCategoryNames[index].name = null
          alert(`Elige una categoría diferente a 'Ninguno'.`)
        }
      // Parent category is any other category
      } else {
        if (this.selectedCategoryNames.length > 1) {
          if (this.parentCategories.findIndex(el => el.name === this.selectedCategoryNames[index].name) === -1) {
            await this.$nextTick()
            this.selectedCategoryNames[index].name = null
            alert('Ya elegiste esa categoría.')
            return
          }
        }
        // Assigning id and name to this.parentCategory
        this.parentCategories[index].name = this.selectedCategoryNames[index].name.slice(
          this.selectedCategoryNames[index].name.indexOf(' ') + 1
        )
        // Assigning id to parentCategory
        this.parentCategories[index].id = this.categoriesMap[ this.categoriesMap.findIndex(el => el.name === this.selectedCategoryNames[index].name) ].id

        console.log('parentCategories', this.parentCategories[index].id)

        // Deleting keywords and ids related to former category id if the user has changed the parent category
        if (this.keywords.length !== 0 && this.formerParentId) {
          if (this.keywords.indexOf(this.categoriesNames[this.formerParentId].toLowerCase()) !== -1) {
            this.keywords.splice(this.keywords.indexOf(this.categoriesNames[this.formerParentId].toLowerCase()), 1)

            this.variations.forEach(variation => {
              if (variation.keywords.indexOf(this.categoriesNames[this.formerParentId].toLowerCase()) !== -1) {
                variation.keywords.splice(variation.keywords.indexOf(this.categoriesNames[this.formerParentId].toLowerCase()), 1)
              }
            })
          }
          this.categories.splice(
            this.categories.indexOf(this.formerParentId),
            1
          )

          console.log('formerParentId', this.formerParentId)
          util.deleteCategoriesAndKeywords(
            this.relationshipsMap,
            this.categoriesNames,
            this.formerParentId,
            this.keywords,
            this.categories
          )
        }

        // Adding the category tree to 'keywords' and 'categories' arrays
        let categoryNameExists = false
        this.keywords.forEach(el => {
          if (this.categoriesNames[this.parentCategories[index].id].toLowerCase() === el) {
            categoryNameExists = true
          }
        })
        if (!categoryNameExists) {
          this.keywords.push(
            this.categoriesNames[this.parentCategories[index].id].toLowerCase()
          )
        }
        this.categories.push(this.parentCategories[index].id)
        util.addCategoryToKeyword(
          this.relationshipsMap,
          this.categoriesNames,
          this.parentCategories[index].id,
          this.keywords,
          this.categories
        )

        console.log('this.keywords', this.keywords)
      }
    },

    /**
     * Add a new category block
     * @param index The index of the last element in selectedCategoryNames
     */
    addCategoryBlock (index) {
      console.log('index', index)

      // Don't add anything if there is no selection
      if (this.parentCategories[index].id === '' || this.parentCategories[index].id === null) {
        alert(`Selecciona una categoría diferente de 'Ninguno' para poder agregar otra categoría`)
        return
      }
      // Push an empty element
      this.parentCategories.push({ name: '', id: '' })
      this.selectedCategoryNames.push({ name: null })
    },

    /**
     * Remove a category block
     * @param index The index of the block to be removed
     */
    removeCategoryBlock (index) {
      if (this.selectedCategoryNames.length > 1) {
        this.selectedCategoryNames.splice(index, 1)
        this.parentCategories.splice(index, 1)
      }

      console.log('this.parentCategories', this.parentCategories)
    },

    /**
     * Delete a feature from the features array
     */
    async deleteFeature (index) {
      console.log('index: ', index)
      if (index === 0 && this.features.length === 1) {
        this.features[0].name = ''
        this.features[0].value = ''
      } else {
        this.features.splice(index, 1)
      }
      console.log('this.features: ', this.features)
    },

    /**
     * Set the statudChanged flag
     */
    changeStatus () {
      this.statusChanged = true
    },

    /**
     * Call the load-image-dialog component
     */
    loadImage (zone, index1 = -1) {
      this.pickFile.index1 = index1
      this.pickFile.zone = zone
      this.LoadImageDialogProps.loadDialog = true
    },

    /**
     * Call the load-video-dialog component
     */
    loadVideo () {
      this.LoadVideoDialogProps.loadDialog = true
    },

    /**
     * Load features
     */
    addFeature () {
      this.features.push({ name: '', value: '' })
    },

    /**
     * Show alert
     */
    activateImageForVariations () {
      if (this.hasVariations === true) {
        alert('Si guardas el documento con esta configuración, ya no podrás desactivarla.')
      } else {
        this.useImagesForVariations = true
      }
    },

    /**
     * Elimates the zero in first digit
     */
    normalizeNumber (type, index) {
      switch (type) {
        case 'RP':
          if (index === -1) {
            this.meta.regularPrice = this.meta.regularPrice * 10 / 10
          } else {
            this.variations[index].meta.regularPrice = this.variations[index].meta.regularPrice * 10 / 10
          }
          break
        case 'SP':
          if (index === -1) {
            this.meta.salePrice = this.meta.salePrice * 10 / 10
          } else {
            this.variations[index].meta.salePrice = this.variations[index].meta.salePrice * 10 / 10
          }
          break
        case 'STK':
          if (index === -1) {
            this.meta.stock = this.meta.stock * 10 / 10
          } else {
            this.variations[index].meta.stock = this.variations[index].meta.stock * 10 / 10
          }
          break
      }
    }
  }
}
</script>
